import { useState } from 'react';
import { CustomEquipment } from '../../../types/sharedTypeImpl.ts';
import { trpc, trpcClient } from '../../../utils/trpc/trpc.ts';
import { CustomEquipmentDialog } from './customEquipmentDialog.tsx';
import { CustomEquipmentsTable } from './customEquipmentsTable.tsx';

interface DialogState {
    isOpen: boolean,
    equipment?: CustomEquipment,
}


export function CustomEquipments() {

    const [customEquipmentDialog, setCustomEquipmentDialog] = useState<DialogState>({ isOpen: false });

    const equipmentsQuery = trpc.equipments.getAllCustom.useQuery(
        {},
        { select: (equipments) => [...equipments].sort((a, b) => a.displayName.localeCompare(b.displayName)) }
    );
    const equipments = equipmentsQuery.data;
    const configsQuery = trpc.cmmConfigs.get.useQuery({ sort: { order: 1 } });
    const cmmConfigs = configsQuery.data;


    const handleIsActiveChange = async (equipment: CustomEquipment, isActive: boolean) => {
        await trpcClient.equipments.updateCustom.mutate({ ...equipment, _id: equipment._id!, isActive });
        equipmentsQuery.refetch();
    }


    return <>
        <div>
            <h2>Custom equipments</h2>
            <button
                onClick={() => setCustomEquipmentDialog({ isOpen: true })}
                children='Add equipment'
            />

            {equipmentsQuery.isLoading && <div>Loading...</div>}
            {equipmentsQuery.error && <div>Error retrieving data</div>}
            {configsQuery.isLoading && <div>Loading configurations...</div>}
            {configsQuery.error && <div>Error retrieving configurations</div>}
            {equipments &&
                <CustomEquipmentsTable
                    style={{ width: '1200px' }}
                    equipments={equipments}
                    onEditClick={equipment => setCustomEquipmentDialog({ isOpen: true, equipment })}
                    onIsActiveChange={handleIsActiveChange}
                />
            }
        </div>

        {(customEquipmentDialog.isOpen && equipments && cmmConfigs) &&
            <CustomEquipmentDialog
                equipmentUnderEdit={customEquipmentDialog.equipment}
                equipments={equipments}
                cmmConfigs={cmmConfigs}
                onEquipmentSaved={() => equipmentsQuery.refetch()}
                onClose={() => { setCustomEquipmentDialog({ isOpen: false }) }}
            />
        }
    </>;
}
